module.exports = __webpack_public_path__ + "img/turbo_off.fbd9c387.png";